export default {
  name: '이전 개인정보처리방침 (2017.06.07)',
  html: `
<div>
  <p class="policy-index" data-index="0" data-label="개인정보 수집에 대한 동의">
    <i>1</i> 개인정보 수집에 대한 동의
  </p>
  <div class="policy-content">
<pre>
㈜전남드래곤즈는 귀하께서 전남드래곤즈 홈페이지(www.dragons.co.kr)의 이용약관의 내용에 대해 「동의한다」버튼 또는 「동의하지 않는다」버튼을 클릭할 수 있는 절차를 마련하여, 「동의한다」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 간주합니다.

※ 본 서비스(사이트)는 만 14세 미만의 아동에 대한 개인정보를 수집하고 있지 않으며, 홈페이지에 아동에게 유해한 정보를 게시하거나 제공하고 있지 않습니다.
</pre>
  </div>
  <p class="policy-index" data-index="1" data-label="개인정보의 수집목적 및 이용목적">
    <i>2</i> 개인정보의 수집목적 및 이용목적
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 회원가입 시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다.
처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행 할 예정입니다.

회원가입
귀하가 전남드래곤즈 홈페이지의 서비스를 이용하기 위해서는 회원가입 시 (희망 ID, 비밀번호, 성명, 전화번호, 핸드폰번호, E-mail 주소, 생년월일, 아이핀DI(중복가입확인정보) )를 필수적으로 입력하셔야 합니다. 그러나, 선택항목(전남드래곤즈와의 관계 등)은 이를 입력하지 않더라도 서비스 이용에는 제한이 없습니다.

- 성명, 아이디, 비밀번호, 생년월일, 아이핀DI(중복가입확인정보) : 회원제 서비스 이용에 따른 본인 식별 절차에 이용
- 이메일주소, 전화번호 : 공지사항 전달, 맞춤 서비스 등을 위한 원활한 의사소통 경로의 확보 등의 안내
- 전화번호 : 쇼핑몰 배송에 대한 정확한 배송지의 확보
- 기타 선택항목 : 개인맞춤 서비스를 제공하기 위한 자료

시즌권
: 필수항목 : 작성자, E-MAIL, 전화번호

쇼핑몰
: 필수항목 : 주문자, E-MAIL, 전화번호, 우편번호, 주소
</pre>
  </div>
  <p class="policy-index" data-index="2" data-label="개인정보의 열람/정정">
    <i>3</i> 개인정보의 열람/정정
  </p>
  <div class="policy-content">
<pre>
귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 개인정보 열람 및 정정을 하고자 할 경우에는 로그인 후 '개인정보수정'을 클릭하여 직접 열람 또는 정정하거나, 개인정보관리책임자에게 서면, 전화, E-mail 등으로 연락하시면 즉시 조치하겠습니다.

귀하가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인정보를 이용하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 조치하겠습니다.

정보주체의 열람·정정·삭제·처리정지 요구 거절 시 불복을 위한 이의제기 절차는 다음과 같습니다.
① 개인정보 관리부서에서 열람 등 요구에 대한 연기 또는 거절 시 요구받은 날로부터 10일 이내에 정당한 사유 및 이의제기 방법 등을 통지
② 개인정보 관리부서에서 정보주체의 이의제기 신청 및 접수(서면, 유선, 이메일) 개인정보 담당자가 내용 확인
③ 개인정보 관리책임자가 처리결과에 대해 최종 검토
④ 개인정보 관리부서에서 정보주체에게 처리결과 통보
</pre>
  </div>
  <p class="policy-index" data-index="3" data-label="개인정보 수집, 이용, 제공에 대한 동의철회">
    <i>4</i> 개인정보 수집, 이용, 제공에 대한 동의철회
  </p>
  <div class="policy-content">
<pre>
회원가입 등을 통해 이루어진 개인정보의 수집, 이용, 제공에 대해 귀하께서 동의하신 내용을 귀하는 언제든지 철회하실 수 있습니다. 동의철회는 홈페이지 첫 화면의 < 동의철회(회원탈퇴)) >를 클릭하거나 개인정보관리책임자에게 서면, 전화, E-mail 등으로 연락하시면 즉시 개인정보의 삭제 등 필요한 조치를 취하겠습니다.
</pre>
  </div>
  <p class="policy-index" data-index="4" data-label="개인정보의 보유기간 및 이용기간">
    <i>5</i> 개인정보의 보유기간 및 이용기간
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지내 수집된 개인정보의 보유기간은 구독해지 또는 회원탈퇴 등 이용목적이 달성된 후까지 입니다. 또한 해지 시 전남드래곤즈 홈페이지는 회원님의 개인정보를 재생이 불가능한 방법으로 즉시 파기하며(개인정보가 제3자에게 제공된 경우에는 제3자에게도 파기하도록 지시합니다.) 다만 다음 각호의 경우에는 각 호에 명시한 기간 동안 개인정보를 보유합니다.
① 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 법령에서 규정한 보존기간 동안 거래내역과 최소한의 기본정보를 보유함
② 보유기간을 회원님에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 회원님의 동의를 받은 경우에는 약속한 보유기간동안 보유함
</pre>
  </div>
  <p class="policy-index" data-index="5" data-label="목적 외 사용 및 제3자에 대한 제공">
    <i>6</i> 목적 외 사용 및 제3자에 대한 제공
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 원칙적으로 정보주체의 개인정보를 수집·이용 목적으로 명시한 범위 내에서 처리하며, 다음의 경우를 제외하고는 정보주체의 사전 동의 없이는 본래의 목적 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다.
① 정보주체로부터 별도의 동의를 받는 경우
② 법률에 특별한 규정이 있는 경우

개인정보 처리의 위탁
① 전남드래곤즈 홈페이지는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
- 수탁업체 : ㈜플랫폼엔
- 위탁업무 : 서비스 운영
- 개인정보의 보유 및 이용기간 : 회원 탈퇴시 혹은 위탁계약 종료시까지

② 전남드래곤즈 홈페이지는 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수 행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임 에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.

③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침 을 통하여 공개하도록 하겠습니다.
</pre>
  </div>
  <p class="policy-index" data-index="6" data-label="개인정보보호를 위한 기술적 대책">
    <i>7</i> 개인정보보호를 위한 기술적 대책
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
① 귀하의 개인정보는 비밀번호에 의해 보호되며, 파일 및 전송 데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.
② 전남드래곤즈 홈페이지는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적 으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
③ 전남드래곤즈 홈페이지는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
④ 해킹 등에 의해 귀하의 개인정보가 유출되는 것을 방지하기 위해, 외부로부터의 침입을 차단하는 장치를 이용하고 있으며, 각 서버마다 침입탐지 시스템을 설치하여 24시간 침입을 감시하고 있습니다.
</pre>
  </div>
  <p class="policy-index" data-index="7" data-label="쿠키에 의한 개인정보 수집">
    <i>8</i> 쿠키에 의한 개인정보 수집
  </p>
  <div class="policy-content">
<pre>
전남드래곤즈 홈페이지는 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'를 운용합니다. 전남드래곤즈 홈페이지가 쿠키를 통해 수집하는 귀하의 개인정보는 (아이디, 페이지 뷰 현황 등)에 한하며, 그 외의 다른 정보는 수집하지 않습니다. 전남드래곤즈 홈페이지가 쿠키를 통해 수집한 귀하의 개인정보는 다음과 같은 목적을 위해 사용됩니다.

전남드래곤즈 홈페이지 회원과 비회원의 접속 빈도나 방문 시간 등을 분석하고 이용자의 취향과 관심분야를 파악하여 타겟(target) 마케팅 및 서비스 개편 등의 척도로 활용합니다. 전남드래곤즈 홈페이지가 진행하는 각종 이벤트에서 귀하의 참여 정도 및 방문 횟수를 파악하여 차별적인 응모 기회를 부여하고 개인의 관심 분야에 따라 차별화된 정보를 제공하기 위한 자료로 이용됩니다.

귀하는 쿠키에 대한 선택권을 가지고 있습니다. 귀하는 웹브라우저에서 [도구] > [인터넷 옵션] > [보안] > [사용자 정의수준]을 선택함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
</pre>
  </div>
  <p class="policy-index" data-index="8" data-label="개인정보관리책임자 및 의견수렴/불만처리">
    <i>9</i> 개인정보관리책임자 및 의견수렴/불만처리
  </p>
  <div class="policy-content">
<pre>
귀하의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 전남드래곤즈 홈페이지는 개인정보관리담당자를 두어 귀하의 개인정보를 관리하고 있으며 개인정보보호와 관련하여 귀하가 의견과 불만을 제기할 수 있는 창구를 개설하고 있습니다. 귀하의 개인정보와 관련한 문의사항 및 불만 사항이 있으시면 아래의 개인정보관리담당자에게 연락 주시면 즉시 조치하여 처리결과를 통보하겠습니다.

개인정보보호 책임자
- 성명 : 백형군
- 소속 : 사무국
- 직책 : 사무국장
- 연락처 : (061)815-0114
- E-MAIL : bhk3222@dragons.co.kr

개인정보관리 책임자
- 성명 : 정용진
- 소속 : 홍보마케팅실
- 직책 : 실장
- 연락처 : (061)815-0114
- E-MAIL : jjj6735@dragons.co.kr

개인정보관리 담당자
- 성명 : 박상옥
- 소속 : 홍보마케팅실
- 직책 : 사원
- 연락처 : (061)815-0114
- E-MAIL : sangok320@dragons.co.kr

이외 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.

※ 아래의 기관은 회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.

개인정보보호 종합지원 포털 (행정안전부 운영)
- 소관업무 : 개인정보 침해사실 신고, 상담 신청, 자료제공
- 홈페이지 : www.privacy.go.kr
- 전화 : 02-2100-3394

개인정보 침해신고센터 (한국인터넷진흥원 운영)
- 소관업무 : 개인정보 침해사실 신고, 상담 신청
- 홈페이지 : Privacy.kisa.or.kr
- 전화 : (국번없이) 118
- 주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원 개인정보침해신고센터

개인정보 분쟁조정위원회 (한국인터넷진흥원 운영)
- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
- 홈페이지 : Privacy.kisa.or.kr
- 전화 : (국번없이) 118
- 주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원 개인정보침해신고센터

개인정보 분쟁조정위원회 (한국인터넷진흥원 운영)
- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
- 홈페이지 : Privacy.kisa.or.kr
- 전화 : (국번없이) 118
- 주소 : (138-950) 서울시 송파구 중대로 135 한국인터넷진흥원 개인정보침해신고센터
</pre>
  </div>
  <p class="policy-index" data-index="9" data-label="개인정보의 파기에 관한 사항">
    <i>10</i> 개인정보의 파기에 관한 사항
  </p>
  <div class="policy-content">
<pre>
회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 개인정보 파기의 절차 및 방법은 다음과 같습니다.
- 파기절차 : 불필요한 개인정보 및 개인정보파일은 내부지침에 따라 다음과 같이 처리하고 있습니다.
- 개인정보의 파기 : 보유기간이 경과한 개인정보는 종료일로부터 지체 없이 파기합니다.
- 파기방법 : 전자적 파일 형태의 정보는 기록을 재생할 수 없도록 파기하며, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
</pre>
  </div>
  <p class="policy-index" data-index="10" data-label="정책 변경에 따른 공지의무">
    <i>11</i> 정책 변경에 따른 공지의무
  </p>
  <div class="policy-content">
<pre>
이 개인정보처리방침은 2004년 10월 4일에 제정되었으며 법령/정책 또는 보안기술의 변경에 따라 내용의 추가/삭제 및 수정이 있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전에 전남드래곤즈 홈페이지를 통해 변경이유 및 내용 등을 공지하도록 하겠습니다.
- 개인정보처리방침 버전번호 : v1.0
- 개인정보처리방침 시행일자 : 2017-06-07
- 개인정보처리방침 이전 버전 : 해당 사항 없음
- 개인정보처리방침 최종변경일자 : 해당 사항 없음
</pre>
  </div>

</div>
  `
}
